import React, { useEffect, useRef } from "react";
import "./rich-text-render.scss";
import { useFocus } from "../../organisms/help/category/use-focus";
/**
 * CosmicJSのRichTextレンダリング用コンポーネント。
 *
 * @component
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} props.html - レンダリングするHTML文字列
 * @returns {JSX.Element} レンダリングされたRichTextコンテンツ
 */
export const RichTextRender: React.FC<{
  html: string;
  enabledPageLink?: boolean;
}> = ({ html, enabledPageLink = false }) => {
  const ref = useRef<HTMLHeadingElement>(null);
  const focus = useFocus(ref);

  useEffect(() => {
    if (!html || !enabledPageLink) return;
    focus();
  }, [enabledPageLink, focus, html, ref]);
  return (
    <div
      ref={ref}
      className="help-rich-text-render"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
